import type { Contact } from '../whats-new/preface';

export type ReportContext = {
  /** Full address of the page the person is on; the query string and the hash are dropped. */
  url: string;
  version: string;
  role?: string | null;
  userAgent: string;
  now?: Date;
};

export const REPORT_SUBJECT = '[Staffing] Signaler un souci';
const USER_AGENT_MAX = 120;

const pad = (n: number) => String(n).padStart(2, '0');

function pageOf(url: string): string {
  try {
    const { origin, pathname } = new URL(url);
    return origin + pathname;
  } catch {
    return url.split(/[?#]/)[0];
  }
}

/** The message people complete, with the context that saves the back-and-forth. */
export function buildReport({ url, version, role, userAgent, now = new Date() }: ReportContext): string {
  const date = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
  const browser = userAgent.length > USER_AGENT_MAX ? `${userAgent.slice(0, USER_AGENT_MAX - 1)}…` : userAgent;
  return [
    'Ce qui se passe : ',
    "Ce que j'attendais : ",
    '',
    'Contexte',
    `Page : ${pageOf(url)}`,
    `Version : ${version}`,
    ...(role ? [`Rôle : ${role}`] : []),
    `Navigateur : ${browser}`,
    `Date : ${date}`,
  ].join('\n');
}

/** Where the cursor starts: the end of the first line, right after « Ce qui se passe : ». */
export function firstLineEnd(text: string): number {
  const i = text.indexOf('\n');
  return i === -1 ? text.length : i;
}

/** `mailto:` link to the owners, sponsor in copy. Line breaks as CRLF, which every mail client reads. */
export function buildMailto(body: string, owners: Contact[], sponsor: Contact): string {
  const query = [
    `cc=${sponsor.email}`,
    `subject=${encodeURIComponent(REPORT_SUBJECT)}`,
    `body=${encodeURIComponent(body.replace(/\r?\n/g, '\r\n'))}`,
  ].join('&');
  return `mailto:${owners.map((o) => o.email).join(',')}?${query}`;
}
